const { client } = require('../../MbaasClient')

export const funcCreateProfile = async (resource, params) => {
  const { data } = await client.user.update('password', {
    oldPassword: params.data.oldPassword,
    newPassword: params.data.newPassword,
  })
  return { data: data }
}
